import { Injectable, Inject, EventEmitter } from '@angular/core';
import { Http, Headers, Response, ResponseContentType} from '@angular/http';
import { Observable } from 'rxjs/Observable';
import { ScriptLoader } from '../services/script-loader.service';
import { ScriptMetaData } from '../dataModels';
import { IErrorHandler } from '../dataModels/contracts/IErrorHandler';
import { Configuration } from '../configurations/shared.config';
import { ResourceService } from '../services/resource.service';
import 'rxjs/add/operator/switchMap';
declare var saveAs: any;
@Injectable()
export class ImportFileService {

    private _errorHandler: IErrorHandler;
    importUrl: string = Configuration.urls.webApiEndpoint + Configuration.urls.importUrl;
    constructor(private _http: Http, @Inject("IErrorHandler") handler: IErrorHandler,
        private _resourceService: ResourceService,
        private loader: ScriptLoader) {

        this._errorHandler = handler;

        var scripts = [

            "../../../../assets/js/reporting/FileSaver.min.js",

        ];

        loader.loadBundle(scripts.map(s => {
            return {
                source: s
            } as ScriptMetaData;
        }));
    }


     ImportFromFile(TemplateUrl: string, FileID: number,Hidden:boolean=false){
       
         var response =  this._http.post(TemplateUrl + "import/" + FileID, null).map(res => res.json()); 
        if(Hidden)
        { 
            jQuery(".loading").css('z-index','7');
            jQuery(".main-nav").css('z-index', '2');
        }
        return response;
    }
    RemoveSesseion(TemplateUrl: string, FileID: string) {
        var response = this._http.get(TemplateUrl + "RemoveSesseion/" + FileID, null).switchMap(res => res.json())
        return response;
    }

    async GetTemplate(TemplateUrl: string): Promise<any> {

        const headerDict = {
            'Content-type': 'application/json',
            'Accept': 'application/json',
            'Access-Control-Allow-Headers': 'Content-Type',
        }

        const requestOptions = {
            headers: new Headers(headerDict),
            responseType: ResponseContentType.Blob,
        };


        var response =await this._http.get(TemplateUrl + "import/Template/Excel", requestOptions).toPromise()
            .then(response => {
 
                var contentType = response.headers.get('Content-Type')
                var blob = new Blob([response.blob()], { type: contentType });
                //var filename = 'file.pdf';

                var contentDisposition = response.headers.get('Content-Disposition');
                var contentDispositionFileName = '';
                if (contentDisposition !== null) {
                    const contentDispositionHeaderResult = contentDisposition.split(';')[1].trim().split('=')[1];
                    contentDispositionFileName = contentDispositionHeaderResult.replace(/"/g, '');
                }

                saveAs(blob, contentDispositionFileName);
                return response;
            })
            .catch(error => {
               return null;
            });
        return response;
    }
    /* saveAs(new Blob([data],
         { type: mime + ';' + this.charset }),
         name + extension, true);

     await this._http.get(this.importUrl + importType).toPromise()
         .then(res => res.blob()).then(blob => saveAs(blob, 'filename'));*/


    //    let completeUrl = this.importUrl + importType;
    //    return Observable.create(observer => {
    //        let xhr = new XMLHttpRequest();

    //        xhr.open('GET', completeUrl, true);
    //        xhr.setRequestHeader('Content-type', 'application/json');
    //        xhr.responseType = 'blob';

    //        xhr.onreadystatechange = function () {
    //            if (xhr.readyState === 4) {
    //                if (xhr.status === 200) {
    //                    
    //                    var contentType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
    //                    var blob = new Blob([xhr.response], { type: contentType });
    //                    var contentDisposition = xhr.getResponseHeader('Content-Disposition');
    //                    var contentDispositionFileName = '';
    //                    if (contentDisposition !== null) {
    //                        const contentDispositionHeaderResult = contentDisposition.split(';')[1].trim().split('=')[1];
    //                          contentDispositionFileName = contentDispositionHeaderResult.replace(/"/g, '');
    //                    }
    //                    observer.next({'blob':blob, 'filename':contentDispositionFileName});
    //                    observer.complete();
    //                    return observer;

    //                } else {
    //                    observer.error(xhr.response);
    //                }
    //            }
    //        }
    //        
    //        xhr.send();
    //    }).subscribe(
    //        _data => saveAs(_data.blob, _data.filename  )),
    //        error => console.log("Error downloading the file."),
    //        () => console.log('Completed file download.');  ;


    //}


}



// WEBPACK FOOTER //
// D:/TFS/Softec.FMS-Core-Live/Source/Frontend/Web/Softec.FMS.Client.WebView-ng4/app/shared/services/import-file.service.ts